"use client";

import { useApplicationPlugin } from "@shesha-io/reactjs";
import { useMemo } from "react";
import { detectBrand, IBrandConfig } from ".";

/**
 * Registers brand data as an application plugin so it is available
 * in Shesha form code editors via `application.brand.*`
 */
export const BrandPlugin = (): null => {
    const brand = useMemo((): IBrandConfig => detectBrand(), []);

    useApplicationPlugin({
        name: "brand",
        data: brand,
        buildMetadata: (appBuilder) => {
            appBuilder.addObject("brand", "Brand", (brandBuilder) => {
                brandBuilder
                    .addString("key", "Brand Key")
                    .addString("name", "Brand Name")
                    .addString("logo", "Logo URL")
                    .addString("favicon", "Favicon URL")
                    .addString("primaryColor", "Primary Color");
            });
        },
    });

    return null;
};
